export default __webpack_public_path__ + "static/media/poolz.59d09aa4.webp";